/* eslint-disable array-callback-return */
import {useEffect, useState} from 'react';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import CustomButtonSecondary from '../../../shared/atomic_components/button/CustomButtonSecondary';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { SegnalazioniService } from '../../../services/controllers/segnalazioni-services/SegnalazioniService';
import { AttachmentService } from '../../../services/controllers/attachment-services/AttachmentService';
import { FileUploader } from 'react-drag-drop-files';

interface SegnalazioneCreateSectionUploadFilesProps {
    notificationFunctions: any;
    idStor: string;
    reminder : boolean
}

const SegnalazioneCreateSectionUploadFiles = ({notificationFunctions, idStor, reminder} : SegnalazioneCreateSectionUploadFilesProps) => {


    let sum = 0

    type attachmentArray = {
        id : number,
        name : string
    }

    const [attachments, setAttachments] = useState<any[]>([]);
    const [attachmentUploaded, setAttachmentsUploaded] = useState<attachmentArray[]>([])
    const attachmentService: AttachmentService = new AttachmentService();


    useEffect(() => {
        //initUploadButtonListener()
    }, []) // [] means run only ones

    useEffect(() => {}, [attachments]);
    useEffect(() => {}, [attachmentUploaded]);

    // function initUploadButtonListener() {
    //     const fileUploader = document.getElementById("upload-btn")
    //     fileUploader?.addEventListener("change", FileSelectHandler, false);
    // }

    async function FileSelectHandler(e : any) {
        const segnalazioniService : SegnalazioniService = new SegnalazioniService();
        const file = e
        sum = sum + file.size
        let fileType = file.type
        if(fileType === '' && file.name.endsWith('.msg')){
            fileType = 'application/vnd.ms-outlook'
        }
        if (segnalazioniService.getAllegati().includes(fileType) && sum < 50000000) {
            addFileToAttachments(file)
        }
        else
            notificationFunctions.setWarningMessage("Il formato del file non è supportato")
        if (sum > 50000000)
           notificationFunctions.setWarningMessage("La somma degli allegati non dev'essere superiore a 50 MB")
    }

    async function addFileToAttachments(file : any) {
        if (checkIfAFileWithSameNameExists(file))
            notificationFunctions.setWarningMessage('Esiste già un file caricato con lo stesso nome')
        else {
            setAttachments(attachments => attachments.concat(file))
            const fd = new FormData();
            fd.append('file', file);
            fd.append('storId', idStor);
            const ft : any = false;
            fd.append('mainDocument', ft);
            const response = await attachmentService.uploadFileToStor(fd);
            if (response && response.id){
                attachmentUploaded.push({id: response.id, name: file.name});
                setAttachmentsUploaded(attachmentUploaded)
                notificationFunctions.setSuccessMessage('File caricato correttamente');
            }
            else{
                const tmpAttachments : any[] = []
                attachments.map(attachment => {
                    if (attachment.name !== file.name) tmpAttachments.push(attachment)
                })
                setAttachments(tmpAttachments)
                notificationFunctions.setErrorMessage('Errore nel caricamento del file');
            }
        }
    }

    function checkIfAFileWithSameNameExists(file : any) {
        let numberOfFileWithSameNameUploaded = 0
        attachmentUploaded.map(attachment => {
            if (attachment.name === file.name)
                numberOfFileWithSameNameUploaded++
        })
        return numberOfFileWithSameNameUploaded > 0
    }

    async function deleteAttachment(file : any) {
        const tmpAttachments : any[] = []
        const tmpAttachmentsUploaded : attachmentArray[] = []
        let tmpId : number = 0
        attachmentUploaded.forEach(attFile =>{
            if(attFile.name === file.name)  tmpId = attFile.id
        })
        const response = await attachmentService.deleteFileFromStor(tmpId);
        if(!response){
            attachments.map(attachment => {
                if (attachment.name !== file.name) tmpAttachments.push(attachment)
            })
            attachmentUploaded.map(attachment =>{
                if (attachment.name !== file.name) tmpAttachmentsUploaded.push(attachment)
            })
            setAttachments(tmpAttachments)
            setAttachmentsUploaded(tmpAttachmentsUploaded)
            notificationFunctions.setSuccessMessage('File eliminato corretamente')
        }
    }

    return (
        <div className="mt-5">
            <div className="mt-4 row shadow card-body">
                <div className="font-large-custom col-10 my-auto">
                    <span className="margin-right-5">Documentazione giustificativa</span>
                    <InfoOutlinedIcon className="color-primary"/>
                </div>
                {reminder ?
                    <div className="mt-3 text-danger">
                        <strong>Ricordarsi di allegare eventuali file a supporto delle informazioni contenute nella sezione “Descrizione dell’ordine”</strong>
                    </div>
                    : <></>
                }
                <div className="mt-4">
                    <strong>File supportati</strong>: docx, doc, pdf, jpg, png, mp4, mp3, zip, 7zip, xlsx, eml, msg
                </div>
                <div className="mt-3">
                    <strong>La somma delle dimensione dei file caricati non può superare i 50 MB</strong>
                </div>
                { attachments.length > 0 ?
                    <div className="row mt-4">
                        <div className="font-medium-custom text-bold color-third col-6">
                            Allegati caricati
                        </div>
                    </div> : <></>
                }
                <div className="row mt-3 mb-3">
                    {attachments.map(attachment => {
                        return <div key={attachment.name} className="col-md-4 mt-3 mb-3 col-sm-12">
                                <div className="card">
                                    <div className="card-body row">
                                        <div className="col-11">
                                            {attachment.name}
                                        </div>
                                        <div className="col-1 d-flex justify-content-end">
                                            <DeleteOutlineOutlinedIcon onClick={() => {deleteAttachment(attachment)}} className="margin-right-5 color-delete pointer"/>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    })}
                </div>
                <FileUploader
                    classes="file-uploader mt-3 text-center" 
                    multiple={false}
                    handleChange={FileSelectHandler}
                    children=
                    {<div>     
                        <div className="mt-5"><FileUploadOutlinedIcon sx={{ fontSize: 80 }} ></FileUploadOutlinedIcon></div>               
                        <div className="mt-3 font-medium-custom color-secondary text-bold" >Trascina qui gli allegati che desideri caricare</div>
                        <div className="mt-3 font-medium-custom color-third">Oppure</div>
                        <CustomButtonSecondary className="mt-3 mb-5">Carica</CustomButtonSecondary>
                    </div>}
                />
            </div>
        </div>
    )
}

export default SegnalazioneCreateSectionUploadFiles;
